export default __webpack_public_path__ + "static/media/IMG_2190.39e9ffb4.jpg";